
(function ($) {
    $(document).ready(() => {
        $(".currency-selector .currency-option").click(onCurrencySelected);
        $(".js-mobile-currency-selector .currency-option").click(onCurrencySelected);
    });

    function setLocation(form) {
        var changeMarket = (clearCart) => {
            $(".js-clear-cart").val(clearCart);
            return new Promise((resolve, reject) => {
                $.ajax({
                    type: "POST",
                    url: form[0].action,
                    data: form.serialize(),
                    success: function (response) {
                        if (response.cart) {
                            console.log("the user has a cart");
                            $('#changeCurrency').modal({
                                show: true,
                                backdrop: 'static',
                            });
                            reject('failed');
                        }
                        else {
                            resolve(response);
                        }
                    }
                });
            });
        }
        changeMarket("false").then((response) => {
            document.location = response.returnUrl;
        })
            .catch(() => {
                $('.js-clear-cart').on('click', () => {
                    changeMarket("true").then((response) => {
                        document.location = response.returnUrl;
                    }).catch(() => { console.log("Error sending request with changeMarket(true).") })
                });
                $('.js-dismiss-change-currency').on('click', () => {
                    console.log("Changing field value back to  $field.data('previousVal')" + $field.data('previousVal'));
                    $field.val($field.data('previousVal'));
                });
            });
    }

    function onLocationSelected(e) {
        e.preventDefault();

        let selectedOption = $(e.target);
        let language = selectedOption.attr("data-language");

        let form = $(this).closest("form");
        form.find("input[name=language]").val(language);

        setLocation(form);
    }

    function onCurrencySelected(e) {
        e.preventDefault();

        let selectedOption = $(e.target);
        let currency = selectedOption.attr("data-currency");

        let form = $(this).closest("form");
        form.find("input[name=currencyCode]").val(currency);

        setLocation(form);
    }
})(window.jQuery);